import { reducer } from 'redux-form';
import { get, set, cloneDeep } from 'lodash';

import * as posTypes from 'PointOfSale/modules/individualServing/state/types';
import { POS_MAX_ITEM_QUANTITY } from 'Common/Constants';

export const formReducer = reducer.plugin({
  TRANSACTION_FORM_NAME: (state, { type, payload }) => {
    switch (type) {
      case posTypes.ADD_ITEM_TO_TRANSACTION:
        const { item, setQuantity } = payload;
        const boughtItems = get(state, 'values.BoughtItems', []);
        const index = boughtItems.findIndex((bi) => bi.ItemId === item.ItemId);
        if (index > -1) {
          const qty = setQuantity
            ? item.Qty
            : boughtItems[index].Qty + item.Qty;
          boughtItems[index].Qty =
            qty > POS_MAX_ITEM_QUANTITY ? POS_MAX_ITEM_QUANTITY : qty;
        } else {
          item.Qty =
            item.Qty > POS_MAX_ITEM_QUANTITY ? POS_MAX_ITEM_QUANTITY : item.Qty;
          boughtItems.push(item);
        }

        let values = set(cloneDeep(state.values), 'BoughtItems', boughtItems);
        values = set(values, 'values.BoughtItems', boughtItems);

        return {
          ...state,
          values,
        };
      default:
        return state;
    }
  },
});



// WEBPACK FOOTER //
// ./src/state/forms/reducer.js